import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgMediaSoundOff24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Sound Off",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.6 2.45a.75.75 0 1 0-1.2-.9l-2.538 3.384V2.751a.749.749 0 0 0-1.213-.59L9.036 7.356H6.888c-1.219 0-2.21.992-2.21 2.21v4.868c0 1.219.991 2.21 2.21 2.21H8.08L4.4 21.55a.75.75 0 0 0 1.2.9zM10.046 14.022l5.316-7.088v-2.64L10.046 8.47zm5.316 5.686-3.747-2.944-.9 1.199 4.935 3.877a.75.75 0 0 0 .791.084.75.75 0 0 0 .422-.674v-6.031A3.345 3.345 0 0 0 19.322 12 3.34 3.34 0 0 0 17.438 9l-2.076 2.767zm-9.184-5.273V9.567a.71.71 0 0 1 .71-.71h1.658v6.289H6.888a.71.71 0 0 1-.71-.711m10.684-4.041c.572.316.96.917.96 1.607s-.388 1.29-.96 1.607z",
  clipRule: "evenodd"
}));

export { SvgMediaSoundOff24 as default };
//# sourceMappingURL=MediaSoundOff24.js.map
